import { Component, OnInit } from '@angular/core';
import { TranslationService, CongresosService, CodigoInvitacionService, UserService, MailService } from '../services/services.index';
import { Congreso } from '../models/congreso.model';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { CategoriaInscripcion } from '../models/categoriaInscripcion.model';
import { User } from '../models/user.model';
import { Router } from '@angular/router';

declare var swal: any;
declare var $;
declare function init_plugins();

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styles: []
})
export class RegisterComponent implements OnInit {

  forma: FormGroup;

  congreso: Congreso;
  categoriaInscripcion: any = '';
  secondStep: boolean = false;
  codigoInvitado: string;

  formInvalid: boolean = false;

  total: number = 0;
  total_usd: number = 0;
  total_inscripcion: number = 0;
  total_inscripcion_usd: number = 0;

  categoriaInscripcionError: boolean = false;
  codigoInvitacionError: boolean = false;
  sociedadError: boolean = false;
  comunicacionesLibres: boolean = true;

  nombre: string;

  hideModal: string = 'hide-modal';

  inscripcionHabilitada: boolean = false;

  loading: boolean = true;

  sociedad: string;

  constructor(public _translationService: TranslationService,
              public _congresosService: CongresosService,
              public _codigoInvitacionService: CodigoInvitacionService,
              public _userService: UserService,
              public router: Router,
              public _mailService: MailService) {

                this.forma = new FormGroup({
                  nombre: new FormControl('', [Validators.required, Validators.minLength(3)]),
                  apellido: new FormControl('', [Validators.required, Validators.minLength(3)]),
                  dni: new FormControl('', [Validators.required, Validators.minLength(3)]),
                  paisResidencia: new FormControl('', [Validators.required, Validators.minLength(2)]),
                  lugarTrabajo: new FormControl('', [Validators.required, Validators.minLength(2)]),
                  cargo: new FormControl(''),
                  direccionLaboral: new FormControl(''),
                  provincia: new FormControl(''),
                  ciudad: new FormControl(''),
                  codPostal: new FormControl(''),
                  paisTrabajo: new FormControl(''),
                  telefono: new FormControl(''),
                  email: new FormControl('', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]),
                  password: new FormControl('', [Validators.required, Validators.minLength(5)])
                });
              }

  ngOnInit() {
    init_plugins();
    this.cargarCongreso();
  }

  switchLanguage(language: string) {
    this._translationService.switchLanguage( language );
  }

  hideModalMethod() {
    this.hideModal = 'hide-modal';
  }

  showModal() {
    this.hideModal = '';
  }

  cargarCongreso() {
    this.loading = true;
    this._congresosService.getCongresoActivo().subscribe(resp => {
      if (resp.length === 1) {
        this.congreso = resp[0];
        let today: number = new Date().getTime();
        if (today < this.congreso.fechaFinInscripcion && today > this.congreso.fechaInicioInscripcion) {
          this.inscripcionHabilitada = true;
        } else {
          this.inscripcionHabilitada = false;
        }
        this.loading = false;
      }

    });
  }

  continuarRegistro() {
    if (this.forma.valid) {
      this.secondStep = true;
      this.formInvalid = false;
    } else {
      this.formInvalid = true;
    }

  }

  selectCategoriaInscripcion() {
    if (this.categoriaInscripcion === '') {
      this.total_inscripcion = 0;
      this.total_inscripcion_usd = 0;
      this.categoriaInscripcionError = true;
    } else if (this.categoriaInscripcion.categoriaInscripcion.invitado) {
      let title: string;
      let text: string;
      let buttons: any = {};
      if (this._translationService.lang === 'es') {
        title = 'Comunicaciones Libres';
        text = '¿Desea enviar un trabajo como comunicaciones libres además del resumen de su exposición como invitado?';
        buttons.si = 'Si';
        buttons.no = 'No';
      } else {
        title = 'Free Communications';
        text = 'Do you want to send a job as free communications in addition to the summary of your exposure as a guest?';
        buttons.si = 'Yes';
        buttons.no = 'No';
      }
      this.categoriaInscripcionError = false;
      swal({
        title: title,
        text: text,
        icon: 'info',
        buttons: [buttons.no, buttons.si]
      })
      .then((willDelete) => {
        if (willDelete) {
          this.total_inscripcion = this.categoriaInscripcion.precio;
          this.total_inscripcion_usd = this.categoriaInscripcion.precio_usd;
          this.comunicacionesLibres = true;
        } else {
          this.total_inscripcion = 0;
          this.total_inscripcion_usd = 0;
          this.comunicacionesLibres = false;
        }
      });
    } else {
      this.categoriaInscripcionError = false;
      this.total_inscripcion = this.categoriaInscripcion.precio;
      this.total_inscripcion_usd = this.categoriaInscripcion.precio_usd;
      this.comunicacionesLibres = true;
    }
  }

  calcularTotal() {
    let total: number;
    total = this.categoriaInscripcion.precio;
    for (let actividad of this.congreso.actividades) {
      total = total + actividad.precio;
      if (!actividad.actividad.selected) {
        total = total - actividad.precio;
      }
    }
    return total;
  }

  esInvitado() {
    if (this.categoriaInscripcion.categoriaInscripcion && this.categoriaInscripcion.categoriaInscripcion.invitado) {
      return true;
    } else {
      return false;
    }
  }

  selectActividad(actividad: any) {

    if (actividad.actividad.selected) {
      actividad.actividad.selected = false;
      this.total = this.total - actividad.precio;
      this.total_usd = this.total_usd - actividad.precio_usd;
    } else {
      actividad.actividad.selected = true;
      this.total = this.total + actividad.precio;
      this.total_usd = this.total_usd + actividad.precio_usd;
    }
  }

  registrarUsuario() {
    // Valido que haya seleccionado una categoria de inscripción
    if (this.categoriaInscripcion !== '') {
      // Si es invitado valida el codigo de invitación.
      if ( this.esInvitado() ) {
        if ( this.codigoInvitado ) {
          this._codigoInvitacionService.validarCodigo(this.codigoInvitado).subscribe(result => {
            if ( result ) {
              this.showModal();
            } else {
              this.codigoInvitacionError = true;
              let title1: string;
              let text1: string;
              if (this._translationService.lang === 'es') {
                title1 = 'Código Inválido';
                text1 = 'El codigo de invitación ingresado es inválido, por favor intente nuevamente con otro.';
              } else {
                title1 = 'Invalid Code';
                text1 = 'The invitation code entered is invalid, please try again with another.';
              }
              swal(title1, text1, 'error');
            }
          });
        } else {
          this.codigoInvitacionError = true;
          let title2: string;
              let text2: string;
              if (this._translationService.lang === 'es') {
                title2 = 'Código Inválido';
                text2 = 'Ingrese el código de invitación.';
              } else {
                title2 = 'Invalid Code';
                text2 = 'Enter the invitation code.';
              }
          swal(title2, text2, 'error');
        }
      } else {
        if (this.categoriaInscripcion.categoriaInscripcion.socio && !this.sociedad) {
          swal('Sociedad Inválida', 'Ingrese la sociedad a la que pertenece', 'error');
          this.sociedadError = true;
        } else {
          this.showModal();
        }
      }
    } else {
      this.categoriaInscripcionError = true;
      let title3: string;
              let text3: string;
              if (this._translationService.lang === 'es') {
                title3 = 'Categoría de Inscripción';
                text3 = 'Seleccione una categoría de inscripción.';
              } else {
                title3 = 'Registration Category';
                text3 = 'Select an enrollment category.';
              }
      swal(title3, text3, 'error');
    }

  }

  cleanErrorStyle() {
    this.codigoInvitacionError = false;
  }

  cleanSociedadErrorStyle() {
    this.sociedadError = false;
  }

  getNombreByLang (objeto: any) {
    if (this._translationService.lang === 'es') {
      objeto.nombre_lang = objeto.nombre_es;
    } else if (this._translationService.lang === 'en') {
      objeto.nombre_lang = objeto.nombre_en;
    }
    return objeto.nombre_lang;
  }

  getTituloByLang (objeto: any) {
    if (this._translationService.lang === 'es') {
      objeto.titulo_lang = objeto.titulo_es;
    } else if (this._translationService.lang === 'en') {
      objeto.titulo_lang = objeto.titulo_en;
    }
    return objeto.titulo_lang;
  }

  confirmarRegistro() {
    let user: User = new User(this.capitalize(this.forma.controls['nombre'].value),
                              this.forma.controls['email'].value,
                              this.forma.controls['password'].value);
    user.apellido = this.capitalize(this.forma.controls['apellido'].value);
    user.lang = this._translationService.lang;
    user.dni = this.forma.controls['dni'].value;
    user.paisResidencia = this.forma.controls['paisResidencia'].value;
    user.lugarTrabajo = this.forma.controls['lugarTrabajo'].value;
    user.cargo = this.forma.controls['cargo'].value;
    user.direccionLaboral = this.forma.controls['direccionLaboral'].value;
    user.provincia = this.forma.controls['provincia'].value;
    user.ciudad = this.forma.controls['ciudad'].value;
    user.codPostal = this.forma.controls['codPostal'].value;
    user.paisTrabajo = this.forma.controls['paisTrabajo'].value;
    user.telefono = this.forma.controls['telefono'].value;
    if (this.forma.controls['paisResidencia'].value === 'AR') {
      user.total = this.total + this.total_inscripcion;
      user.moneda = 'ARG';
    } else {
      user.total = this.total_usd + this.total_inscripcion_usd;
      user.moneda = 'USD';
    }
    user.congreso = this.congreso._id;
    user.categoriaInscripcion = {
      categoriaInscripcion: this.categoriaInscripcion.categoriaInscripcion._id,
      precio: this.total_inscripcion,
      precio_usd: this.total_inscripcion_usd,
    };
    user.invitado = this.categoriaInscripcion.categoriaInscripcion.invitado;
    user.socio = this.categoriaInscripcion.categoriaInscripcion.socio;
    if (user.socio) {
      user.sociedad = this.sociedad;
    }
    user.comunicacionesLibres = this.comunicacionesLibres;
    user.actividades = [];
    for (let actividad of this.congreso.actividades) {
      if (actividad.actividad.selected) {
        let objetoActividad: any = {
          actividad: actividad.actividad._id,
          precio: actividad.precio,
          precio_usd: actividad.precio_usd
        };
        user.actividades.push(objetoActividad);
      }
    }

    this.hideModalMethod();
    this._userService.crearInscripcion(user).subscribe((resp: User) => {
      this._userService.login(user, true).subscribe(correcto => {
        this._codigoInvitacionService.usarCodigoInvitacion(this.codigoInvitado).subscribe(data => {});
        this._mailService.mailParaUsuario('registro', this.congreso.titulo_es, user.name, user.apellido, user.email, user.lang, this.congreso.sociedadOrganizadora).subscribe(ok => {});
        this.router.navigate(['/dashboard']);
      });
    },
    err => {
      if (err.status === 500) {
        console.log(err);
        let lang: string = this._translationService.lang;
          let tituloSwal: string;
          let mensajeSwal: string;
          if (lang === 'es') {
            tituloSwal = 'Email inválido';
            mensajeSwal = 'El email ya existe en el sistema. Intente nuevamente con otro email.';
          } else {
            tituloSwal = 'Invalid Email';
            mensajeSwal = 'The email already exists in the system. Try again with another email.';
          }
          swal(tituloSwal, mensajeSwal, 'error');
      }
    });
  }

  // function to decide if mobile or not
  isMobile() {
    return ($(window).width() < 767);
  }

  capitalize(texto: string) {
    return texto.toLowerCase()
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
  }

}



// WEBPACK FOOTER //
// ./src/app/login/register.component.ts